import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const BetInputLabel = () => {
  return <InlineText2>Ставка сверх пакета, ₽/день</InlineText2>;
};
